import { Injectable, signal, WritableSignal } from '@angular/core';

/** Holds the byte-level upload progress (0-100) of the most recent tracked upload request. */
@Injectable({ providedIn: 'root' })
export class UploadProgressService {
  readonly progress: WritableSignal<number> = signal<number>(0);

  /**
   * Publishes the current upload percentage.
   * @param percent Value between 0 and 100.
   */
  report(percent: number): void {
    this.progress.set(percent);
  }

  /** Sets the progress back to 0 before a new upload starts. */
  reset(): void {
    this.progress.set(0);
  }
}
